import React from 'react'

import type { IconProps } from '../iconProps'
import { s } from './icon.style'

export const MailOpenedIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ size = 16, name = 'icon', color, style, ...props }: IconProps, ref) => {
    return (
      <svg
        viewBox="0 0 24 24"
        css={s}
        style={{ width: size, color, ...style }}
        data-svg-name={name}
        {...props}
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.99 8C21.99 7.28 21.62 6.65 21.05 6.3L12 1L2.95 6.3C2.38 6.65 2 7.28 2 8V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18L21.99 8ZM12 13L3.74 7.84L12 3L20.26 7.84L12 13Z"
          fill="black"
          fill-opacity="0.87"
        />
      </svg>
    )
  },
)
